/* eslint-disable camelcase */
import ar_AR from './ar_AR.json';
import ar_SA from './ar_SA.json';
import bg_BG from './bg_BG.json';
import cs_CZ from './cs_CZ.json';
import de_DE from './de_DE.json';
import de_LI from './de_LI.json';
import el_GR from './el_GR.json';
import en_AU from './en_AU.json';
import en_CA from './en_CA.json';
import en_IL from './en_IL.json';
import en_NZ from './en_NZ.json';
import en_US from './en_US.json';
import es_ES from './es_ES.json';
import et_EE from './et_EE.json';
import fr_CA from './fr_CA.json';
import fr_FR from './fr_FR.json';
import fr_MC from './fr_MC.json';
import hr_HR from './hr_HR.json';
import hu_HU from './hu_HU.json';
import it_IT from './it_IT.json';
import lt_LT from './lt_LT.json';
import lv_LV from './lv_LV.json';
import pl_PL from './pl_PL.json';
import pt_BR from './pt_BR.json';
import ro_RO from './ro_RO.json';
import sk_SK from './sk_SK.json';
import zh_CN from './zh_CN.json';

export default {
  ar_AR,
  ar_SA,
  bg_BG,
  cs_CZ,
  de_DE,
  de_LI,
  el_GR,
  en_AU,
  en_CA,
  en_IL,
  en_NZ,
  en_US,
  es_ES,
  et_EE,
  fr_CA,
  fr_FR,
  fr_MC,
  hr_HR,
  hu_HU,
  it_IT,
  lt_LT,
  lv_LV,
  pl_PL,
  pt_BR,
  ro_RO,
  sk_SK,
  zh_CN
};
